export * from './auth/auth.service';
export * from './auth/auth.component';
export * from './auth/register/register.component';
export * from './auth/reset-password/reset-password.component';
export * from './auth/remover-cadastro/remover-cadastro.component';
export * from './auth/auth.guard';
export * from './auth/admin.guard';
export * from './auth/auth.interceptor';
export * from './auth/roles';

export * from './sidebar/sidebar.component';
